<template>
  <Dialog
    v-model:visible="visibleLocal"
    @hide="$emit('close')"
    maximizable
    modal
    header="История изменений"
    :style="{ width: '70vw' }"
    style="max-height: 70vh"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <p class="m-0">
      <DataTable :value="filteredHistory" :loading="isLoading">
        <Column field="action" header="Действие">
          <template #body="slotProps">
            <span v-if="slotProps.data.operation_type">
              {{ store.operationsMap.get(slotProps.data.operation_type) }}
            </span>
            <span v-else>-</span>
          </template></Column
        >
        <Column field="user" header="Пользователь">
          <template #body="slotProps">
            <span v-if="slotProps.data.changed_by">
              {{ getUserName(slotProps.data.changed_by) }}
            </span>
            <span v-else>-</span>
          </template>
        </Column>
        <Column field="time" header="Дата и время">
          <template #body="slotProps">
            {{ convertDateFromUTC(slotProps.data.changed_at) }}
          </template>
        </Column>
        <Column field="changes" header="Что изменилось">
          <template #body="slotProps">
            <div v-if="slotProps.data.operation_type == 'UPDATE'">
              <div
                class="m-b-4"
                v-for="ch in slotProps.data.changes"
                :key="ch.field"
              >
                {{ ch.field }}: с <span class="f-w-600">{{ ch.old }}</span> на
                <span class="f-w-600">{{ ch.new }}</span>
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </Column>
      </DataTable>
    </p>
  </Dialog>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { getUserName } from "@/services/utils/Names";
import { useHistoryStore } from "@/store/history/history";

import {
  convertDateFromUTC,
  formatDateStringFromYYYYMMDD,
} from "@/services/utils/DateParser";

const store = useHistoryStore();

const filteredHistory = ref([]);
const isLoading = ref(false);

const props = defineProps<{
  entity: string;
  object_id: number | string;
  visible: boolean;
}>();

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);

watch(
  () => props.visible,
  (newValue) => {
    filteredHistory.value = [];
    if (newValue && props.object_id != 0) {
      isLoading.value = true;
      store
        .getHistory(props.entity, props.object_id)
        .then(() => {
          filteredHistory.value = store.historyList.map((historyEntry) => {
            return {
              ...historyEntry, // Копируем все свойства объекта
              changes: getFilteredChanges(historyEntry.changes), // Заменяем поле `changes`
            };
          });

          filteredHistory.value = filteredHistory.value.filter(
            (e) => e.changes.length > 0 || e.operation_type == "INSERT"
          );
        })
        .finally(() => {
          isLoading.value = false;
        });
    }
  }
);

const getFilteredChanges = (changes: any) => {
  const changesResult = [] as HistoryLog[];
  for (const key in changes) {
    if (!store.excludedFields.includes(key)) {
      const keyName = store.fieldsMap.get(key) || key;
      let newValue = changes[key].new;
      let oldValue = changes[key].old;

      if (oldValue != null) {
        if (store.dateFields.includes(key)) {
          newValue = formatDateStringFromYYYYMMDD(newValue);
          oldValue = formatDateStringFromYYYYMMDD(oldValue);
        }

        if (key == "brand_pk") {
          newValue = newValue["brand_name"] || null;
          oldValue = oldValue["brand_name"] || null;
        } else if (key == "shop_id") {
          newValue = newValue["shop_name"] || null;
          oldValue = oldValue["shop_name"] || null;
        } else if (key == "source_slug" || key == "platform_slug") {
          newValue = newValue["name"] || null;
          oldValue = oldValue["name"] || null;
        } else if (key == "role_id") {
          newValue = `${newValue["name"]} (организация ${newValue["department"]["organization"]["name"]}, департамент ${newValue["department"]["name"]})`;
          oldValue = `${oldValue["name"]} (организация ${oldValue["department"]["organization"]["name"]}, департамент ${oldValue["department"]["name"]})`;
        }

        if (newValue === "" || newValue == null) newValue = "'пустое значение'";
        if (oldValue === "" || oldValue == null) oldValue = "'пустое значение'";

        changesResult.push({
          field: keyName,
          new: newValue,
          old: oldValue,
        });
      }
    }
  }
  return changesResult;
};

interface HistoryLog {
  field: string;
  new: any;
  old: any;
}
</script>
